import { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useClearCrossRegionAccessMutation } from '~/api/v2/hooks';

const removeAllCookies = () => {
  const allCookies = Cookies.get();

  Object.keys(allCookies).forEach((cookieName) => {
    Cookies.remove(cookieName, { path: '/' });
    Cookies.remove(cookieName);
  });
};

const LogoutPage = ({ signOut }: { signOut?: () => void | Promise<void> }) => {
  const [clearCrossRegionAccess, { isLoading }] = useClearCrossRegionAccessMutation();

  useEffect(() => {
    if (!signOut) return;

    const run = async () => {
      if (isLoading) return;
      try {
        await clearCrossRegionAccess();
        await signOut();
      } catch (error) {
        console.error('error signing out: ', error);
      } finally {
        // Do NOT clear sessionStorage/localStorage here (UD-4171). This finally runs as a
        // microtask after `await signOut()` resolves but BEFORE the browser commits the
        // authenticator remote's Cognito /logout navigation. On its /logout remount the
        // remote reads the Okta id_token it stored in localStorage to drive upstream Okta
        // single-logout (id_token_hint); wiping storage destroys that token, so the Okta
        // session survives and the next user is re-authorized as the previous one. The
        // remote owns teardown of its own auth tokens. Mirrors dh-ai-presentation-service,
        // which does nothing here but await signOut(). removeAllCookies() is kept because it
        // only touches app-origin, JS-readable cookies — js-cookie cannot see the
        // cross-domain Okta/Cognito session cookies, nor the localStorage id_token — so it
        // is timing-safe and does not affect SLO.
        removeAllCookies();
      }
    };

    run();
  }, [signOut]);

  return null;
};

export default LogoutPage;
